import React, {Component} from "react";
import view from '../images/history-view.jpg'

import './UserAppHistoryView.css';
import { Button, ToggleButton } from "../components/FormUI";
import Appointment from "../api/Appointment";
import DateHelper from "../components/DateHelper";
import moment from 'moment';
import AppointmentService from "../api/services/AppointmentService";
import { SanitizeClassNames } from "../common";
import { LoadingSpinner } from "../components/BiopedUI";

const appService = new AppointmentService();

function isEmpty(o){
    for(let p in o){
        return false;
    }
    return true;
}

export default class UserAppHistoryView extends Component{
    rawList = [];
    state = {list:<LoadingSpinner className="absCenter" />};
    componentDidMount(){
        console.log('User History:', this.props.user)
        appService.getByUserId(this.props.user.clientId).then((apps) => {
            //this.list = apps.map((app) => <AppCard app={app} />);
            //console.log('App history:', apps);
            
            this.rawList = apps.reverse();
            this.filterList();
            //this.setState({list:this.rawList.map((app) => <AppCard app={app} />)});
            //console.log("Search Apps:", this.list);
        })

    }

    filterList(){
        let list = (!isEmpty(this.state.filters))? this.rawList.filter((item) => {
            let filter = this.state.filters;
            console.log("Filter:", filter)
            for(let p in filter){
               // console.log('FilterList: ', item, "  Filter[" + p + "] = " , filter[p])
               let fItem = filter[p];
               for(let i=0; i < fItem.length; i++){
                   if((item[p] || '').toLowerCase() === fItem[i])return true;
               }
                
            }
            return false;
        }): this.rawList;
        this.setState({list:list.map((app) => <AppCard app={app} />)});
    }

    onAddFilter(name, value){
        let filters = this.state.filters || {};
        if(filters[name] == null){
            filters[name] = [];
        }
        filters[name].push(value);
        this.state.filters = filters;
        this.filterList();
        //this.setState({filter:filters});
        
    }

    onRemoveFilter(name, value){
        let filters = this.state.filters || {};
        if(filters[name]){
            filters[name] = filters[name].filter((v)=>{
                return v != value;
            })

            if(filters[name].length === 0){
                delete filters[name];
            }
        }
        
        //delete filters[filterName];        
        this.state.filters = filters;
        this.filterList();
    }

    

    render(){
        let user = this.props.user;

        return(
            /*<img src={view} style={{height:'500px'}} />*/
            <div className={SanitizeClassNames(this,'app-history-view')}>
                <div>
                    <div className='table hmax vmax'>
                        <div>
                            <div>
                                <div className='header table hmax'>
                                    <div>
                                        <div>
                                            <div><h1>Appointment History</h1></div>
                                            <div><h2>{user.fullName}</h2></div>
                                            <div>
                                            <ToggleButton className='filter-toggle' caption='No shows' onIcon='check' 
                                                on={()=>{
                                                    this.onAddFilter('status', 'no-show');
                                                }}
                                                off={() => this.onRemoveFilter('status', 'no-show') } 
                                            />
                                            <ToggleButton className='filter-toggle' caption='Cancellations' onIcon='check' 
                                                on={()=>{
                                                    this.onAddFilter('status', 'cancelled');
                                                }}
                                                off={() => this.onRemoveFilter('status', 'cancelled') } 
                                            />
                                            </div>
                                        </div>
                                        <div className='align-right'>   
                                            {/*<Button caption='Show PDF' />
                                            <Button caption='Print' />*/}
                                            <Button caption='Close' onClick={this.props.requestClose} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className='vmax'>
                                <div className='app-history-list'>{this.state.list}</div>                        
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


class AppCard extends Component{
    render(){
        let app = new Appointment(this.props.app);
        return(
            <div className='app-card table hmax align-middle'>
                <div>
                    <div>Date</div>
                    <div>{moment(app.start).format('ddd MMM D, YYYY')}</div>
                    
                </div>
                <div>
                    <div>Time</div>
                    <div>{DateHelper.FormatTime(app.start)} - {DateHelper.FormatTime(app.end)}</div>
                    
                </div>
                <div>
                    <div>Pedorthist</div>
                    <div>{app.doctor.fullName}</div>
                    
                </div>
                <div>
                    <div>Type of Service</div>
                    <div>{app.appointmentType.name}</div>
                    
                </div>
                <div>
                    <div>Status</div>
                    <div>{app.status}</div>
                    
                </div>
                <div>
                    <div>Notes</div>
                    <div>
                        <div className="note-content" dangerouslySetInnerHTML={{ __html: (app.comment || '').replace(/\n/g, "<br />") }} />
                    </div>
                    
                </div>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/UserAppHistoryView.js